// SheetJS — ÚNICO punto de uso, EXCLUSIVAMENTE DE ESCRITURA. NUNCA importar
// XLSX.read/readFile ni parsear archivos no confiables: la 0.18.5 del registro
// npm arrastra CVE-2023-30533 (prototype pollution) en el PARSER; el parche
// (0.20.x) solo está en el CDN de SheetJS. Mientras sea write-only, no aplica.
import * as XLSX from 'xlsx';

/**
 * Descarga un `.xlsx` a partir de filas planas (clave = encabezado de columna).
 * Uso típico: `exportToXlsx('facturas', rows.map(r => ({ Fecha: ..., Monto: ... })))`.
 */
export function exportToXlsx(fileName: string, rows: Record<string, unknown>[]): void {
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Datos');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}
